import React, { useRef, useEffect, useState } from 'react'
import { useLoader } from 'react-three-fiber';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import * as THREE from 'three'
import config from './config'

function setBoundingBox(obj) {
	return obj.geometry.computeBoundingBox()
}

function remakeMaterial(obj, index) {
	obj.reflectivity = 0.5

	if (obj.material.type === 'MeshPhongMaterial') {
		let param = {
			name: obj.name,
			color: obj.material.color,
			opacity: obj.material.opacity,
			transparent: obj.material.transparent,
		}

		if (obj.material.specular !== undefined) {
			param.specular = obj.material.specular
		}

		if (obj.material.shininess !== undefined) {
			param.shininess = obj.material.shininess
		}

		obj.material = new THREE.MeshPhongMaterial(param)
	} else {
		const color = (index === 0) ? new THREE.Color(0.7, 0.7, 0.7) : obj.material.color;
		let param = { name: obj.name, color: color }

		if (config.collision.isTarget(obj.name)) {
			obj.castShadow = true
			param.side = THREE.DoubleSide
		} else {
			obj.receiveShadow = true
		}

		obj.material = new THREE.MeshLambertMaterial(param)
	}

	return obj
}

const Stage = () => {
	const ref = useRef()
	const { children: stage } = useLoader(FBXLoader, config.stage.model)
	const [isLoaded, setIsLoaded] = useState(false)

	useEffect(() => {
		console.log('Log / Stage building', stage)
		stage[1].children.map((obj, index) => {
			if (obj.type === undefined || obj.type !== 'Mesh') {
				return obj
			}

			return setBoundingBox(remakeMaterial(obj, index))
		})

		// ステージを再背面に置く
		stage[1].renderOrder = -1
		setIsLoaded(true)
	}, [stage, isLoaded])

	if (isLoaded) {
		return (
			<mesh ref={ref} name="URB/ZOO:stage">
				<primitive attach="geometry" scale={config.stage.scale} object={stage[1]} />
			</mesh>
		)
	} else {
		return (
			<></>
		)
	}
}

export default Stage